import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import jaCommon from './locales/ja/common.json';
import jaProfile from './locales/ja/profile.json';
import jaGameCard from './locales/ja/gameCard.json';
import jaLibrary from './locales/ja/library.json';
import jaMediaCard from './locales/ja/mediaCard.json';
import jaReviewDialog from './locales/ja/reviewDialog.json';
import jaSettings from './locales/ja/settings.json';
import enCommon from './locales/en/common.json';
import enProfile from './locales/en/profile.json';
import enGameCard from './locales/en/gameCard.json';
import enLibrary from './locales/en/library.json';
import enMediaCard from './locales/en/mediaCard.json';
import enReviewDialog from './locales/en/reviewDialog.json';
import enSettings from './locales/en/settings.json';

export const SUPPORTED_LANGUAGES = ['ja', 'en'] as const;
export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];

// 各言語の自言語表記（UIロケールに依存せず常に母語で表示）
export const LANGUAGE_LABELS: Record<SupportedLanguage, string> = {
  ja: '日本語',
  en: 'English',
};

// 各言語の対応状況メモ。説明はその言語の話者向けなので、必ずその言語で書く
// （現在のUI言語では切り替えない）。空文字は説明なしで表示しない。
export const LANGUAGE_DESCRIPTIONS: Record<SupportedLanguage, string> = {
  ja: '',
  en: 'English support is rolling out gradually',
};

export const LANGUAGE_STORAGE_KEY = 'app-language';

export const resources = {
  ja: { common: jaCommon, profile: jaProfile, gameCard: jaGameCard, mediaCard: jaMediaCard, library: jaLibrary, reviewDialog: jaReviewDialog, settings: jaSettings },
  en: { common: enCommon, profile: enProfile, gameCard: enGameCard, mediaCard: enMediaCard, library: enLibrary, reviewDialog: enReviewDialog, settings: enSettings },
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    // JP ファースト：判定不能時は日本語にフォールバック
    fallbackLng: 'ja',
    supportedLngs: SUPPORTED_LANGUAGES as unknown as string[],
    // 'en-US' 等のサブタグを 'en' に丸める
    load: 'languageOnly',
    ns: ['common', 'profile', 'gameCard', 'mediaCard', 'library', 'reviewDialog', 'settings'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false, // React は既に XSS 対策済み
    },
    detection: {
      // localStorage > ブラウザ設定 の順で言語を決定
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ['localStorage'],
    },
  });

export default i18n;
